import {DBBase} from "./DB/DBBase";
import {DBDropdowns} from "./DB/DBDropdowns";
import {DBPartners} from "./DB/DBPartners";
import {DBActivityLogs} from "./DB/DBActivityLogs";
import {DBEmailLogs} from "./DB/DBEmailLogs";

import {SuccessAlert, ErrorAlert, WarningAlert} from "./UI/Alerts";
import {Validation} from "./UI/Validation";

window.DBBase = DBBase;
window.DBDropdowns = DBDropdowns;
window.DBPartners = DBPartners;
window.DBActivityLogs = DBActivityLogs;
window.DBEmailLogs = DBEmailLogs;

window.SuccessAlert = SuccessAlert;
window.ErrorAlert = ErrorAlert;
window.WarningAlert = WarningAlert;

window.Validation = Validation;

require('./Libraries/axios');
require('./Libraries/collect');
require('./Libraries/moment');
